export const validatePassword = (value: string) => {
  const hasUppercase = /[A-Z]/.test(value);
  const hasLowercase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecial = /[!#@$&]/.test(value);
  const hasOther = /[^A-Za-z0-9!#@$&]/.test(value);
  const validItems = [hasUppercase, hasLowercase, hasNumber, hasSpecial];
  return validItems.filter((i) => i).length >= 3 && !hasOther;
};
